import { render } from "./brand-detail.vue?vue&type=template&id=038960cf"
import script from "./brand-detail.vue?vue&type=script&lang=js"
export * from "./brand-detail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__